<template>
    <div id="about">
        <div class="about1">
            <img :src="url+banner.images[0]" alt="" @click="jumpbannerpage(banner2.url,index)">
        </div>
        <div class="about2">
            <p class="title">{{about2.title}}</p>
            <div v-html="about2.subtitle"></div>
        </div>
        <div class="about3">
            <p class="title">{{about3.title}}</p>
            <ul class="list1">
                <li class="wow animate__animated animate__fadeInUp" v-for="(item,index) in about3.images" :key="index"><img :src="url+item" alt=""></li>
            </ul>
        </div>
        <div class="about4">
            <img src="@/assets/about/about4img.png" alt="" class="bg">
            <div class="about4Box" >
                  <el-carousel :interval="5000" arrow="always" indicator-position="none">
                    <el-carousel-item v-for="(item,index) in about4" :key="index">
                        <div class="about4carousel">
                            <div>
                                <p class="p1">{{item.title}}</p>
                                <p class="p2" v-html="item.subtitle"></p>
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
        <div class="about5">
            <p class="title">理念、远景、使命</p>
            <ul class="wow animate__animated animate__fadeInUp">
                <li v-for="(item,index) in about5" :key="index" v-show="index<about5Number">
                    <div class="about5Box1" v-show="index%2==0">
                        <div class="left">
                            <p>{{item.title}}</p>
                            <img :src="url+item.images" alt="">
                        </div>
                        <div class="right">
                            <p>{{item.subtitle}}</p>
                        </div>
                    </div>
                    <div class="about5Box2" v-show="index%2!=0">
                        <div class="left">
                            <p>{{item.subtitle}}</p>
                        </div>
                        <div class="right">
                            <p>{{item.title}}</p>
                            <img :src="url+item.images" alt="">
                        </div>
                    </div>
                </li>
            </ul>
            <div class="buttonBox" v-show="about5status" @click="about5Number=1;about5status=false" >
                <span :class="about5status?'':'change'" class="go"><img src="@/assets/about/go.png" alt="" ></span>
                <span class="buttonSpan">收起</span>
            </div>
            <div class="buttonBox" v-show="!about5status" @click="about5Number=5;about5status=true" >
                <span :class="about5status?'':'change'" class="go"><img src="@/assets/about/go.png" alt="" ></span>
                <span class="buttonSpan">展开</span>
            </div>
        </div>
    </div>
</template>

<script>
import { rotationmap,about } from '@/api/api'
export default {
    name:"about",
    data(){
        return {
            url : window.url,
            banner: {}, 
            about2:{},
            about3:[],
            about4:[

            ],
            about5status:true,
            about5Number:5,
            about5:[

            ],
        }
    },
    mounted(){
        var that =this
        rotationmap({'type':6}).then((response) => {
            response.data.data[0].images = response.data.data[0].images.split(',')
            that.banner = response.data.data[0]
        })
        about().then((response) => {
            that.about2 = response.data.data[0][0]
            response.data.data[1][0].images = response.data.data[1][0].images.split(',')
            that.about3 = response.data.data[1][0]
            that.about4 = response.data.data[2]
            that.about5 = response.data.data[3]
            this.about5Number = response.data.data[3].length
            //初始化动画
            that.$nextTick(()=>{
                that.$wow.init()
            })
        })
    },
    methods:{
        jumpbannerpage(e,y){
            let url = e.split(';')
            if(url[y] != this.$route.path) {
                this.$router.push(url[y])
            }
        }
    }
}
</script>

<style lang="less">
:root {
    --web-title-fontsize: 30px;
    --web-subtitle-fontsize: 22px;
    --web-text-fontsize: 16px;
} 
@media (min-width:750px) {
    #about{
        .about1{
            img{
                width: 100%;
                display: block;
            }
        }
        .about2{
            padding: 32px;
            width: 1300px;
            margin:-310px  auto 0;
            background: #FFFFFF;
            box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
            position: relative;
            z-index: 2;
            .title{
                font-size: var(--web-title-fontsize);
                color: #333333;
                position: relative;
                margin-left: 20px;
            }
            .title::after{
                content:"";
                display: block;
                position: absolute;
                width: 8px;
                height: 100%;
                background: #5B7CFA;
                left: -22px;
                top: 0px;
            }
            div{
                font-size: var(--web-subtitle-fontsize);
                font-weight: 400;
                color: #333333;
                margin-top: 14px;
                line-height: 1.8;
            }
        }
        .about3{
            width: 1300px;
            margin:70px auto 0;
            
            .title{
                font-size: var(--web-title-fontsize);
                color: #333333;
                position: relative;
                margin-left: 20px;
                margin-bottom: 50px;
            }
            .title::after{
                content:"";
                display: block;
                position: absolute;
                width: 8px;
                height: 100%;
                background: #5B7CFA;
                left: -22px;
                top: 0px;
            }
            ul{
                display: flex;
                flex-wrap: wrap;
            }
            .list1{
                img{
                    width: 100%;
                }
                li{
                    flex:0 0 33%;
                }
            }
        }
        .about4{
            margin-top: 100px;
            position: relative;
            .bg{
                width: 100%;
                display: block;
            }
            .about4Box{
                width: 800px;
                height: 60%;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%,-50%);
                .about4carousel{
                    width: 621px;
                    height: 100%;
                    margin:0 auto;
                    border-radius: 50%;
                    background: rgba(255, 255, 255,0.1);
                    backdrop-filter: blur(8px);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    div{
                        .p1{
                            font-size: var(--web-subtitle-fontsize);
                            color: #FFFFFF;
                            text-align: right;
                        }
                        .p2{
                            width: 448px;
                            font-size: var(--web-text-fontsize);
                            color: #FFFFFF;
                            text-indent: 3rem;
                        }
                    }
                }
            }
        }
        .about5{
            width: 1300px;
            margin:70px auto 40px;
            .title{
                font-size: var(--web-title-fontsize);
                color: #333333;
                position: relative;
                width: 266px;
                margin:0 auto 50px;
            }
            .title::after{
                content:"";
                display: block;
                position: absolute;
                width: 8px;
                height: 100%;
                background: #5B7CFA;
                left: -22px;
                top: 0px;
            }
            .about5Box1{
                display: flex;
                justify-content: center;
                .left{
                    position: relative;
                    padding-right: 95px;
                    border-right: 2px solid #E63521;;
                    p{
                        text-align: right;
                        margin-bottom: 12px;
                        font-size: var(--web-text-fontsize);
                        font-weight: normal;
                        color: #E63521;
                    }
                    img{
                        width: 500px;
                    }
                }
                .left::after{
                    content:"";
                    display: block;
                    width: 36px;
                    height: 36px;
                    background: #E63521;
                    position: absolute;
                    top: 0;
                    right: -19px;
                    border-radius: 50%;
                }
                .right{
                    margin-left: 63px;
                    p{
                        width: 538px;
                        height: 221px;
                        background-image: url('../../assets/about/about5Bg.png');
                        background-size: 100% 100%;
                        padding: 43px 52px;
                        font-size: var(--web-subtitle-fontsize);
                        font-weight: normal;
                        color: #595959;
                    }
                }
            }
            .about5Box2{
                display: flex;
                justify-content: center;
                .right{
                    position: relative;
                    padding-left: 95px;
                    border-left: 2px solid #E63521;;
                    p{
                        text-align: left;
                        margin-bottom: 12px;
                        font-size: var(--web-text-fontsize);
                        font-weight: normal;
                        color: #E63521;
                    }
                    img{
                        width: 500px;
                    }
                }
                .right::after{
                    content:"";
                    display: block;
                    width: 36px;
                    height: 36px;
                    background: #E63521;
                    position: absolute;
                    top: 0;
                    left: -19px;
                    border-radius: 50%;
                }
                .left{
                    margin-right: 55px;
                    p{
                        width: 538px;
                        height: 221px;
                        background-image: url('../../assets/about/about5Bg2.png');
                        background-size: 100% 100%;
                        padding: 43px 52px;
                        font-size: var(--web-subtitle-fontsize);
                        font-weight: normal;
                        color: #595959;
                    }
                }
            }
            .buttonBox{
                width: 127px;
                border-radius: 10px 10px 10px 10px;
                opacity: 1;
                border: 2px solid #E63521;
                margin: 12px auto 0;
                font-size: var(--web-text-fontsize);
                font-weight: normal;
                color: #E63521;
                display: flex;
                justify-content: center;
                padding: 8px 0;
                cursor: pointer;
                .go{
                    width: 26px;
                    height: 26px;
                    background: #E63521;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 50%;
                    margin-right: 12px;
                    img{
                        width: 10px;
                        
                    }
                }
                .change{
                    transform: rotate(180deg);
                }
            }
        }
    }
}
@media screen and (max-width:750px) {
    #about{
        .about1{
            img{
                width: 100%;
                display: block;
            }
        }
        .about2{
            padding: 2rem;
            width: 100%;
            margin: 0 auto 0;
            background: #FFFFFF;
            // box-shadow: 0rem 0.1875rem 0.375rem 0.0625rem rgba(0,0,0,0.16);
            position: relative;
            z-index: 2;
            .title{
                font-size: 1.5rem;
                color: #333333;
                position: relative;
                margin-left: 1.25rem;
            }
            .title::after{
                content:"";
                display: block;
                position: absolute;
                width: 0.5rem;
                height: 100%;
                background: #5B7CFA;
                left: -1.375rem;
                top: 0rem;
            }
            div{
                font-size: 0.75rem;
                font-weight: 400;
                color: #333333;
                margin-top: 0.875rem;
                line-height: 1.8;
            }
        }
        .about3{
            width: 100%;
            padding: 2rem;
            .title{
                font-size: 1.5rem;
                color: #333333;
                position: relative;
                margin-left: 1.25rem;
                margin-bottom: 1.25rem;
            }
            .title::after{
                content:"";
                display: block;
                position: absolute;
                width: 0.5rem;
                height: 100%;
                background: #5B7CFA;
                left: -1.375rem;
                top: 0rem;
            }
            ul{
                display: flex;
                margin:0rem 0.625rem 0;
            }
            .list1{
                flex:0 0 33.3%;
            }
            .list2{
                flex:0 0 25%;
            }
            .list1 img{
                width: 100%;
            }
            .list2 img{
                width: 100%;
            }
        }
        .about4{
            position: relative;
            .bg{
                width: 100%;
                display: block;
            }
            .about4Box{
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0%;
                left: 0%;
                .el-carousel__container{
                    height: 7.9375rem;
                }
                .about4carousel{
                    width: 100%;
                    height: 100%;
                    margin:0 auto;
                    border-radius: 50%;
                    background: rgba(255, 255, 255,0.1);
                    backdrop-filter: blur(0.5rem);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    div{
                        .p1{
                            font-size: 0.875rem;
                            color: #FFFFFF;
                            text-align: right;
                        }
                        .p2{
                            width: 100%;
                            font-size: 0.75rem;
                            color: #FFFFFF;
                            text-indent: 3rem;
                        }
                    }
                }
            }
        }
        .about5{
            width: 100%;
            padding:2rem;
            .title{
                font-size: 1.5rem;
                color: #333333;
                position: relative;
                width: 16.625rem;
            }
            .title::after{
                content:"";
                display: block;
                position: absolute;
                width: 0.5rem;
                height: 100%;
                background: #5B7CFA;
                left: -1.375rem;
                top: 0rem;
            }
            .about5Box1{
                display: flex;
                justify-content: center;
                .left{
                    position: relative;
                    padding-right: 1.25rem;
                    border-right: 0.125rem solid #E63521;
                    ;
                    p{
                        text-align: right;
                        margin-bottom: 0.75rem;
                        font-size: 0.75rem;
                        font-weight: normal;
                        color: #E63521;
                    }
                    img{
                        width: 10rem;
                    }
                }
                .left::after{
                    content:"";
                    display: block;
                    width: 2.25rem;
                    height: 2.25rem;
                    background: #E63521;
                    position: absolute;
                    top: 0;
                    right: -1.1875rem;
                    border-radius: 50%;
                }
                .right{
                    margin-left: 1.25rem;
                    p{
                        width: 10rem;
                        height: 3.875rem;
                        background-image: url('../../assets/about/about5Bg.png');
                        background-size: 100% 100%;
                        padding: 0.625rem 1.25rem;
                        font-size: 0.75rem;
                        font-weight: normal;
                        color: #595959;
                    }
                }
            }
            .about5Box2{
                display: flex;
                justify-content: center;
                .right{
                    position: relative;
                    padding-left: 1.25rem;
                    border-left: 0.125rem solid #E63521;
                    ;
                    p{
                        text-align: left;
                        margin-bottom: 0.75rem;
                        font-size: 0.75rem;
                        font-weight: normal;
                        color: #E63521;
                    }
                    img{
                        width: 10rem;
                    }
                }
                .right::after{
                    content:"";
                    display: block;
                    width: 2.25rem;
                    height: 2.25rem;
                    background: #E63521;
                    position: absolute;
                    top: 0;
                    left: -1.1875rem;
                    border-radius: 50%;
                }
                .left{
                    margin-right: 1.25rem;
                    p{
                        width: 10rem;
                        height: 3.75rem;
                        background-image: url('../../assets/about/about5Bg2.png');
                        background-size: 100% 100%;
                        padding: 0.625rem 1.25rem;
                        font-size: 0.75rem;
                        font-weight: normal;
                        color: #595959;
                    }
                }
            }
            .buttonBox{
                width: 7.9375rem;
                border-radius: 0.625rem 0.625rem 0.625rem 0.625rem;
                opacity: 1;
                border: 2px solid #E63521;
                margin: 0.75rem auto 0;
                font-size: 1.125rem;
                font-weight: normal;
                color: #E63521;
                display: flex;
                justify-content: center;
                padding: 0.5rem 0;
                .go{
                    width: 1.625rem;
                    height: 1.625rem;
                    background: #E63521;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 50%;
                    margin-right: 0.75rem;
                    img{
                        width: 0.625rem;
                    }
                }
                .change{
                    transform: rotate(180deg);
                }
                .buttonSpan{
                    cursor: pointer;
                }
            }
        }
        .about6{
            width: 100%;
            margin:4.375rem auto 0;
            .title{
                font-size: 2rem;
                color: #333333;
                position: relative;
                width: 16.625rem;
                margin:0 0 3.125rem;
            }
            .title::after{
                content:"";
                display: block;
                position: absolute;
                width: 0.5rem;
                height: 100%;
                background: #5B7CFA;
                left: -1.375rem;
                top: 0rem;
            }
            .about6lList{
                display: flex;
                .el-menu-vertical-demo{
                    width: 12.5rem;
                }
                .right{
                    padding: 1.5rem 1.625rem;
                    .about6Title{
                        font-size: 2.875rem;
                        font-weight: 400;
                        color: #343434;
                        border-bottom: 0.0625rem solid #DCDCDC;
                        margin-bottom: 1.25rem;
                        padding-bottom: 1.25rem;
                    }
                    .about6Content{
                        font-size: 1.5rem;
                        font-weight: 400;
                        color: #343434;
                    }
                }
            }
        }
    }
 
}
</style>